import { useEffect } from 'react'
import { PrimaryButton } from '@!/components/Button'
import { useReadBook } from '@!/Hooks'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'

const ReadBookLinkButton = ({ content }) => {
  const [readContentMutation, redirectUrl, apiError, setApiError] = useReadBook('purchased')

  useEffect(() => {
    if (!redirectUrl) return

    window.location.href = redirectUrl
  }, [redirectUrl])

  const handleClick = () => {
    readContentMutation.mutate({ contentId: content.content_id })
  }

  const handleApiError = () => {
    console.log(apiError)
    setApiError(null)
  }

  return (
    <>
      <PrimaryButton variant="outline" width="100%" height="37px" maxW="240px" whiteSpace="normal" onClick={handleClick}>
        今すぐ読む
      </PrimaryButton>
      <CircularProgressModal isOpen={readContentMutation.isPending} />
      <ConfirmPopupModal text="エラーが発生しました。" handlePopup={() => handleApiError()} isOpen={!!apiError} />
    </>
  )
}

export default ReadBookLinkButton
